'use client';
import React from 'react';

import Loading from 'features/generic/components/Loading/Loading';
import CancelButton from 'features/form/components/CancelButton/CancelButton';
import ModalWrapper from 'features/modal/components/ModalWrapper/ModalWrapper';
import SubmitButton from 'features/form/components/SubmitButton/SubmitButton';
import WarningIcon from 'assets/img/icons/alert.svg';

import * as styles from './styles';
import {formatListingTypeDisplayName} from 'utils/helpers';

const ChangeListingsTypeForm = (props) => {
    return (
        <ModalWrapper>
            <div style={styles.container}>
                {props.apiSuccess && (
                    <ul>
                        {props.apiSuccess.map((message, index) => {
                            return (<li key={'api-success-' + index} style={styles.success}>{message}</li>)
                        })}
                    </ul>
                )}
                {props.apiErrors && (
                    <ul>
                        {props.apiErrors.map((error, index) => {
                            return (<li key={'api-error-' + index} style={styles.error}>{error}</li>)
                        })}
                    </ul>
                )}
                {!props.hasFinishedSubmission && (<WarningIcon style={styles.warning} />)}
                {props.includeVipWarning && !props.hasFinishedSubmission && (
                    <div style={styles.warningText}>
                        All active VIP State subscriptions will also be canceled.
                    </div>
                )}
                <div style={styles.message}>
                    Please confirm the following listings will be changed to the following type:&nbsp;
                    <b style={styles.reason}>
                        {formatListingTypeDisplayName(props.toType)}
                    </b>
                    <br />
                    <ul>
                    {props.listings.map((listing) => {
                        return (<li key={listing.listing_id}><b style={styles.reason}>{listing.listing_name}</b></li>);
                    })}
                    </ul>
                    <br />
                    <br />
                </div>
                {!props.isSaving && !props.hasFinishedSubmission && (
                    <SubmitButton handleClick={props.handleSubmit} submitText="Confirm" />
                )}
                {props.isSaving && <Loading style={styles.loading} />}
                {!props.isSaving && !props.hasFinishedSubmission && (
                    <CancelButton handleClick={props.handleClose} />
                )}
            </div>
        </ModalWrapper>
    );
};

export default ChangeListingsTypeForm;
